<template>
  <div>
    <v-container>
      <div class="text-h5 text-sm-h5 text-md-h4 text-lg-h4 ma-3 text-xl-h4 text-center">
        Cuadrantes de tienda
      </div>

      <v-row style="height:60px" no-gutters class="mt-2">
        <v-col style="width:200px" cols="auto">
          <DateFind class="mb-n3" label="Fecha" v-model="fecha"></DateFind>

          <!-- <v-text-field
            outlined
            dense
            v-model="fecha"
            label="Fecha"
            style="height:40px"
            type="date"
            class="mr-2"
          ></v-text-field> -->
        </v-col>

        <template v-if="!$store.state.esDir || $store.state.dir == null">
          <v-col>
              <DirFind label="Tienda" ref="dirCtrl" class="mr-2 mb-n4" v-model="dir" @change="cargar"></DirFind>


            <!-- <v-autocomplete
              v-model="dir"
              dense="true"
              hide-selected
              :items="itemsDir"
              :search-input.sync="searchDir"
              item-value="DirId"
              item-text="DirNom"
              outlined
              no-data-text="Introduzca texto a buscar"
              label="Tienda"
              cache-items="true"
              return-object="true"
              ref="dirCtrl"
              @change="cargar"
            ></v-autocomplete> -->
          </v-col>
        </template>

        <v-col style="width: 120px" cols="auto">
          <v-btn
            color="primary"
            class="ml-2"
            @click="procesarCuadrantes(true)"
            >
              Mostrar
          </v-btn>
        </v-col>
       <v-col
          v-if="cuadrante.length > 0"
          style="width:190px"
          cols="auto"
        >
          <v-btn
            color="secondary"
            class="ml-2"
            @click="imprimirCuadrante"
          >
            <v-icon left>
              mdi-printer
            </v-icon>

            Imprimir / PDF
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <!-- <v-data-table
            :headers="headers"
            :items="cuadrante"
            :items-per-page="15"
            style="overflow: scroll"
            mobile-breakpoint="0"
            class="elevation-1">
          </v-data-table>           -->

          <div
            v-if="cuadrante.length > 0"
            ref="cuadranteImprimible"
            id="cuadrante-imprimible"
          >
            <div class="cabecera-impresion">
              <h1>Cuadrante semanal de tienda</h1>

              <div class="datos-cuadrante">
                <span>
                  <strong>Tienda:</strong>
                  {{ nombreTienda }}
                </span>

                <span>
                  <strong>Semana:</strong>
                  {{ titLunes }} - {{ titDomingo }}
                </span>
              </div>
            </div>
          <v-simple-table dense class="tabla-cuadrante">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">DEPENDIENTA</th>
                  <th class="text-center">{{titLunes}}</th>
                  <th class="text-center">{{titMartes}}</th>
                  <th class="text-center">{{titMiercoles}}</th>
                  <th class="text-center">{{titJueves}}</th>
                  <th class="text-center">{{titViernes}}</th>
                  <th class="text-center">{{titSabado}}</th>
                  <th class="text-center">{{titDomingo}}</th>
                  <th class="text-center">SEMANA</th>
                </tr>              
              </thead>
              <tbody>
                <tr style="background-color: white" v-for="item in cuadrante" :key="item.name" v-bind:style="item.ResumenFecha ? 'font-weight:bold' : 'font-weight:normal'">
                  <!-- <td class="sticky-col first-col" style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; min-width: 250px"> {{ item.Dependienta }} </td> -->
                  <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; min-width: 250px"> {{ item.Dependienta }} </td>
                  <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; min-width: 147px; max-width: 147px">
                    <table>
                      <tr style="background-color: white">
                        <td style="text-align:center; border:0px"><span v-html="formatHoras(item.Lunes.Horario)"></span></td>
                      </tr>
                      <tr style="background-color: white">
                        <td style="text-align:center; border:0px"><span v-if="item.Lunes.Horas != null">Horas:</span> {{ item.Lunes.Horas }}</td>
                      </tr>
                      <tr style="background-color: white">
                          <!-- <td style="text-align:center; font-weight:bold; border:0px">{{ item.Lunes.Excepcion }}</td> -->
                      </tr>
                    </table>
                  </td>
                  <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; min-width: 147px; max-width: 147px">
                    <table>
                      <tr style="background-color: white">
                        <td style="text-align:center; border:0px"><span v-html="formatHoras(item.Martes.Horario)"></span></td>
                      </tr>
                      <tr style="background-color: white">
                        <td style="text-align:center; border:0px"><span v-if="item.Martes.Horas != null">Horas:</span> {{ item.Martes.Horas }}</td>
                      </tr>
                      <tr style="background-color: white">
                          <!-- <td style="text-align:center; font-weight:bold; border:0px">{{ item.Martes.Excepcion }}</td> -->
                      </tr>
                    </table>
                  </td>
                  <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; min-width: 147px; max-width: 147px">
                    <table>
                      <tr style="background-color: white">
                        <td style="text-align:center; border:0px"><span v-html="formatHoras(item.Miercoles.Horario)"></span></td>
                      </tr>
                      <tr style="background-color: white">
                        <td style="text-align:center; border:0px"><span v-if="item.Miercoles.Horas != null">Horas:</span> {{ item.Miercoles.Horas }}</td>
                      </tr>
                      <tr style="background-color: white">
                          <!-- <td style="text-align:center; font-weight:bold; border:0px">{{ item.Miercoles.Excepcion }}</td> -->
                      </tr>
                    </table>
                  </td>
                  <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; min-width: 147px; max-width: 147px">
                    <table>
                      <tr style="background-color: white">
                        <td style="text-align:center; border:0px"><span v-html="formatHoras(item.Jueves.Horario)"></span></td>
                      </tr>
                      <tr style="background-color: white">
                        <td style="text-align:center; border:0px"><span v-if="item.Jueves.Horas != null">Horas:</span> {{ item.Jueves.Horas }}</td>
                      </tr>
                      <tr style="background-color: white">
                          <!-- <td style="text-align:center; font-weight:bold; border:0px">{{ item.Jueves.Excepcion }}</td> -->
                      </tr>
                    </table>
                  </td>
                  <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; min-width: 147px; max-width: 147px">
                    <table>
                      <tr style="background-color: white">
                        <td style="text-align:center; border:0px"><span v-html="formatHoras(item.Viernes.Horario)"></span></td>
                      </tr>
                      <tr style="background-color: white">
                        <td style="text-align:center; border:0px"><span v-if="item.Viernes.Horas != null">Horas:</span> {{ item.Viernes.Horas }}</td>
                      </tr>
                      <tr style="background-color: white">
                          <!-- <td style="text-align:center; font-weight:bold; border:0px">{{ item.Viernes.Excepcion }}</td> -->
                      </tr>
                    </table>
                  </td>
                  <td style="background-color: mistyrose; border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; min-width: 147px; max-width: 147px">
                    <table>
                      <tr style="background-color: mistyrose">
                        <td style="text-align:center; border:0px"><span v-html="formatHoras(item.Sabado.Horario)"></span></td>
                      </tr>
                      <tr style="background-color: mistyrose">
                        <td style="text-align:center; border:0px"><span v-if="item.Sabado.Horas != null">Horas:</span> {{ item.Sabado.Horas }}</td>
                      </tr>
                      <tr style="background-color: mistyrose">
                          <!-- <td style="text-align:center; font-weight:bold; border:0px">{{ item.Sabado.Excepcion }}</td> -->
                      </tr>
                    </table>
                  </td>
                  <td style="background-color: mistyrose; border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; min-width: 147px; max-width: 147px">
                    <table>
                      <tr style="background-color: mistyrose">
                        <td style="text-align:center; border:0px"><span v-html="formatHoras(item.Domingo.Horario)"></span></td>
                      </tr>
                      <tr style="background-color: mistyrose">
                        <td style="text-align:center; border:0px"><span v-if="item.Domingo.Horas != null">Horas:</span> {{ item.Domingo.Horas }}</td>
                      </tr>
                      <tr style="background-color: mistyrose">
                          <!-- <td style="text-align:center; font-weight:bold; border:0px">{{ item.Domingo.Excepcion }}</td> -->
                      </tr>
                    </table>
                  </td>
                  <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; min-width: 147px; max-width: 147px; font-weight:bold">
                    <table>
                      <tr>
                        <td style="text-align:center; border:0px solid black">{{ item.TotalSemana.Horario }}</td>
                      </tr>
                      <tr>
                        <td style="text-align:center; border:0px solid black"><span v-if="item.TotalSemana.Horas != null">Horas:</span> {{ item.TotalSemana.Horas }}</td>
                      </tr>
                      <tr>
                          <td style="text-align:center; font-weight:bold; border:0px solid black">{{ item.TotalSemana.Excepcion }}</td>
                      </tr>
                    </table>
                  </td>
                </tr>                
              </tbody>
            </template>
          </v-simple-table>
           </div>

          <div
            v-else
            class="text-center grey--text py-6"
          >
            Selecciona una tienda y pulsa Mostrar para cargar el cuadrante.
          </div>

        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="auto">
          <v-expansion-panels inset>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Leyenda
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td style="border-top: 1px solid lightgrey; border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">A</td>
                        <td style="border-top: 1px solid lightgrey; border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">ASUNTOS PROPIOS</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">B</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">BAJA MEDICA</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">BO</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">BODA</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">C</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">CURSO O REUNION</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">CI</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">CITACION OFICIAL</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">D</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">DESCANSO SEMANAL</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">E</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">DESCANSO POR SABADO FESTIVO</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">ES</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">SUSPENSIÓN DE EMPLEO Y SUELDO</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">F</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">FESTIVO O ABSTENCION</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">FF</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">FALLECIMIENTO FAMILIAR</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">H</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">HUELGA</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">I</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">INGRESO HOSPITALARIO</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">M</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">ASISTENCIA MEDICO</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">MU</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">MUDANZA</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">N</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">NEGOCIACION SINDICAL</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">P</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">PERMISO RETRIBUIDO</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">R</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">RECUPERACION ASUNTOS PROPIOS</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">S</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">HORAS SINDICALES</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">V</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">VACACIONES</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">X</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">ACUMULACIÓN DE HORAS COVID</td>
                      </tr>
                      <tr>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; width:20px">Z</td>
                        <td style="border-bottom: 1px solid lightgrey; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; width:300px">RECUPERACIÓN DE HORAS COVID</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import axios from "axios";
  import DirFind from "../components/DirFind.vue";
  import DateFind from "../components/DateFind.vue";
  import funcs from "../funcs";

  // import pdf from "vue-pdf";
  // import { mapState, mapMutations, mapActions } from "vuex";
  import { mapState } from "vuex";
  export default {
    computed:{
        ...mapState(['empId', 'perId', 'urlRaiz']),

          nombreTienda() {
            if (!this.dir) {
              return "";
            }

            return (
              this.dir.DirNom ||
              this.dir.Nombre ||
              this.dir.Text ||
              `Tienda ${this.dir.DirId || ""}`
            );
          }
    },
    data () {
      return {
        loading: true,
        fecha: "",
        // fecha: null,
        dir: {},
        titLunes: "LUNES",
        titMartes: "MARTES",
        titMiercoles: "MIERCOLES",
        titJueves: "JUEVES",
        titViernes: "VIERNES",
        titSabado: "SABADO",
        titDomingo: "DOMINGO",
        // itemsDir: [],
        // searchDir: null,

        headers: [
          { text: 'DEPENDIENTA', value: 'Dependienta', class:'col_dpta' },
          { text: 'LUNES', value: 'Lunes', width: "120" },
          { text: 'MARTES', value: 'Martes', width: "120" },
          { text: 'MIERCOLES', value: 'Miercoles', width: "120" },
          { text: 'JUEVES', value: 'Jueves', width: "120" },
          { text: 'VIERNES', value: 'Viernes', width: "120" },
          { text: 'SABADO', value: 'Sabado', width: "120" },
          { text: 'DOMINGO', value: 'Domingo', width: "120" },
          { text: 'TOTAL', value: 'TotalSemana', width: "120" },
        ],

        cuadrante: []
      }
    },
    components:{
      DirFind,
      DateFind
      // pdf
    },
    watch: {
      // searchDir(val){
      //   var CampoBusqueda = "DirNom";
      //   var ValorBuscar = val;
      //   var NumRegsPag = 15; 
      //   var NumPag =  1; 

      //   var controllerParameters = {
      //             Action: "GET_DATA_LIST_PAGINATED",
      //             CampoBusqueda: CampoBusqueda,
      //             ValorBuscar: ValorBuscar,
      //             NumRegsPag: NumRegsPag,
      //             NumPag: NumPag,
      //             EmpId: this.empId 

      //             // ParameterList: [
      //             //     { Type: "PARAMETER", Name: "CampoBusqueda", Operator: "=", Value: CampoBusqueda },
      //             //     { Type: "PARAMETER", Name: "ValorBuscar", Operator: "=", Value: ValorBuscar },
      //             //     { Type: "PARAMETER", Name: "NumRegsPag", Operator: "=", Value: NumRegsPag },
      //             //     { Type: "PARAMETER", Name: "NumPag", Operator: "=", Value: NumPag },
      //             //     { Type: "PARAMETER", Name: "EmpId", Operator: "=", Value: this.empId },
      //             //     { Type: "PARAMETER", Name: "TipoDir", Operator: "=", Value: "" }
      //             // ]
      //         } ;

      //   var AuthToken = localStorage.getItem('token');
      //   // axios({ method: "POST", "url": this.urlRaiz + "/api/Dir", "data": JSON.stringify(controllerParameters), "headers": { "content-type": "application/json" } }).then(result => {
      //   axios({ method: "POST", "url": this.urlRaiz + "/api/dir", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } }).then(result => {
      //         this.itemsDir = result.data.EntsList;
      //     });
      //   },      
      },
    mounted() {
      // this.itemsDir.push(this.$store.state.dir);
      this.dir = this.$store.state.dir;

      var hoy = new Date();
      this.fecha =  hoy.getFullYear() + "-" + (hoy.getMonth() + 1) + "-" + hoy.getDate();
    },
    methods: {
      // ...mapMutations('MensajesRecibidos', ['entidadActualSet']),

imprimirCuadrante() {
  const contenido = this.$refs.cuadranteImprimible;

  if (!contenido) {
    alert("Primero debes cargar un cuadrante.");
    return;
  }

  const ventanaImpresion = window.open(
    "",
    "_blank",
    "width=1600,height=900"
  );

  if (!ventanaImpresion) {
    alert(
      "El navegador ha bloqueado la ventana de impresión. Permite las ventanas emergentes para esta página."
    );
    return;
  }

  const htmlCuadrante = contenido.innerHTML;

  ventanaImpresion.document.open();

  ventanaImpresion.document.write(`
    <!DOCTYPE html>
    <html lang="es">
      <head>
        <meta charset="UTF-8">
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        >

        <title>Cuadrante semanal</title>

        <style>
          @page {
            size: A3 landscape;
            margin: 8mm;
          }

          * {
            box-sizing: border-box;
          }

          html,
          body {
            margin: 0;
            padding: 0;
            font-family: Arial, Helvetica, sans-serif;
            color: #000;
            background: #fff;
          }

          body {
            padding: 5mm;
            zoom: 1.35;
          }

          .cabecera-impresion {
            margin-bottom: 12px;
          }

          .cabecera-impresion h1 {
            margin: 0 0 8px 0;
            text-align: center;
            font-size: 22px;
          }

          .datos-cuadrante {
            display: flex;
            justify-content: space-between;
            gap: 20px;
            margin-bottom: 10px;
            font-size: 12px;
          }

          .v-data-table,
          .v-data-table__wrapper {
            width: 100%;
            overflow: visible !important;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
          }

          thead {
            display: table-header-group;
          }

          tr {
            break-inside: avoid;
            page-break-inside: avoid;
          }

          th,
          td {
            border: 1px solid #999 !important;
            padding: 3px !important;
            font-size: 13px;
            line-height: 1.25;
            vertical-align: middle;
            overflow-wrap: anywhere;
          }

          th {
            background: #eeeeee !important;
            text-align: center !important;
            font-weight: bold;
          }

          th:first-child,
          td:first-child {
            width: 18%;
            min-width: 0 !important;
            max-width: none !important;
            text-align: left;
          }

          th:not(:first-child),
          td:not(:first-child) {
            width: 10.75%;
            min-width: 0 !important;
            max-width: none !important;
            text-align: center;
          }

          td table {
            width: 100%;
            border: 0;
            table-layout: fixed;
          }

          td table tr,
          td table td {
            border: 0 !important;
          }

          td table td {
            padding: 1px !important;
            font-size: 13px;
            text-align: center;
          }

          tbody > tr > td:nth-child(7),
          tbody > tr > td:nth-child(8) {
            background: mistyrose !important;
          }

          strong {
            font-weight: 700;
          }

          @media print {
            body {
              padding: 0;
            }

            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
          }
        </style>
      </head>

      <body>
        <div id="documento-cuadrante">
          ${htmlCuadrante}
        </div>
      </body>
    </html>
  `);

  ventanaImpresion.document.close();

  ventanaImpresion.onload = () => {
    ventanaImpresion.focus();

    setTimeout(() => {
      ventanaImpresion.print();
    }, 300);
  };
},

      escaparHtml(valor) {
        return String(valor || "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
      },
      procesarCuadrantes(){
        return new Promise((resolve) => {
          var controllerParameters = {
                    Action: "GET_CUADRANTE_SEMANAL_TIENDA",
                    Fecha: this.fecha,
                    DirId: this.dir.DirId
          } ;       
          var AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/dir", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } }).then(result => {
              // if (mostrarCuadrante){
              result.data.sort(this.compararArrayCuadrantes)

              this.cuadrante = [];
              var dptaAnt = "-";
              var cuadranteObj = {};
              var ultElemIndex = 0;
              var formatoHora = new Intl.NumberFormat("es-ES", {style: "decimal", minimumFractionDigits:2, maximumFractionDigits: 2})
              // var TotalHorasSemana = 0;
              let fechaSemana = new Date(result.data[0].Semana);
              const lunesStr = funcs.UtcDateTimeToStr(fechaSemana, "date");
              const martesStr = funcs.UtcDateTimeToStr(fechaSemana.setDate(fechaSemana.getDate() + 1), "date");
              const miercolesStr = funcs.UtcDateTimeToStr(fechaSemana.setDate(fechaSemana.getDate() + 1), "date");
              const juevesStr = funcs.UtcDateTimeToStr(fechaSemana.setDate(fechaSemana.getDate() + 1), "date");
              const viernesStr = funcs.UtcDateTimeToStr(fechaSemana.setDate(fechaSemana.getDate() + 1), "date");
              const sabadoStr = funcs.UtcDateTimeToStr(fechaSemana.setDate(fechaSemana.getDate() + 1), "date");
              const domingoStr = funcs.UtcDateTimeToStr(fechaSemana.setDate(fechaSemana.getDate() + 1), "date");

              this.titLunes = "LUNES " + lunesStr;
              this.titMartes = "MARTES " + martesStr;
              this.titMiercoles = "MIERCOLES " + miercolesStr;
              this.titJueves = "JUEVES " + juevesStr;
              this.titViernes = "VIERNES " + viernesStr;
              this.titSabado = "SABADO " + sabadoStr;
              this.titDomingo = "DOMINGO " + domingoStr;
              result.data.forEach(element => {
                if (element.Dependienta != null && element.Dependienta != "")
                {
                  if (element.Dependienta != dptaAnt){
                    cuadranteObj = {Dependienta: element.Dependienta, Lunes: "", Martes: "", Miercoles: "", Jueves: "", Viernes: "", Sabado: "", Domingo: "", TotalSemana: "", ResumenFecha: element.ResumenFecha};
                    this.cuadrante.push(cuadranteObj);
                    ultElemIndex = this.cuadrante.length - 1;
                    // TotalHorasSemana = 0;
                  }

                  var fecha = new Date(element.Fecha);
                  var diaSemana = fecha.getDay(fecha);
                  // TotalHorasSemana += element.Horas;
 
                  // TotalHorasSemana = element.HorasSemana;

                  // var infoDiaObj = {Horario: element.TiendaDependientaFecha, Horas: formatoHora.format(element.Horas), Excepcion: element.vbpi};
                  var infoDiaObj = {Horario: element.Turnos, Horas: formatoHora.format(element.Horas), Excepcion: element.vbpi};
                  // var infoSemanaObj = {Horario: "", Horas: formatoHora.format(TotalHorasSemana), Excepcion: ""};

                  if (diaSemana == 1) { // Lunes
                    this.cuadrante[ultElemIndex].Lunes = infoDiaObj;
                    // this.cuadrante[ultElemIndex].Lunes = element.TiendaDependientaFecha + String.fromCharCode(10) + "     Horas: " + formatoHora.format(element.Horas) + "\r\n" + element.vbpi;

                    // var pruebaObj = {Horario: element.TiendaDependientaFecha, Horas: formatoHora.format(element.Horas), Excepcion: element.vbpi};
                    // this.cuadrante[ultElemIndex].Prueba = pruebaObj;
                  }
                  else if (diaSemana == 2){
                    this.cuadrante[ultElemIndex].Martes = infoDiaObj;
                    // this.cuadrante[ultElemIndex].Martes = element.TiendaDependientaFecha + "     Horas: " + formatoHora.format(element.Horas) + "\r\n" + element.vbpi;
                  }
                  else if (diaSemana == 3){
                    this.cuadrante[ultElemIndex].Miercoles = infoDiaObj;
                    // this.cuadrante[ultElemIndex].Miercoles = element.TiendaDependientaFecha + "     Horas: " + formatoHora.format(element.Horas) + "\r\n" + element.vbpi;
                  }
                  else if (diaSemana == 4){
                    this.cuadrante[ultElemIndex].Jueves = infoDiaObj;
                    // this.cuadrante[ultElemIndex].Jueves = element.TiendaDependientaFecha + "     Horas: " + formatoHora.format(element.Horas) + "\r\n" + element.vbpi;
                  }
                  else if (diaSemana == 5){
                    this.cuadrante[ultElemIndex].Viernes = infoDiaObj;
                    // this.cuadrante[ultElemIndex].Viernes = element.TiendaDependientaFecha + "     Horas: " + formatoHora.format(element.Horas) + "\r\n" + element.vbpi;
                  }
                  else if (diaSemana == 6){
                    this.cuadrante[ultElemIndex].Sabado = infoDiaObj;
                    // this.cuadrante[ultElemIndex].Sabado = element.TiendaDependientaFecha + "     Horas: " + formatoHora.format(element.Horas) + "\r\n" + element.vbpi;
                  }
                  else if (diaSemana == 0 && !element.ResumenSemana){
                    this.cuadrante[ultElemIndex].Domingo = infoDiaObj;
                    // this.cuadrante[ultElemIndex].Domingo = element.TiendaDependientaFecha + "     Horas: " + formatoHora.format(element.Horas) + "\r\n" + element.vbpi;
                  }
                  else if (diaSemana == 0 && element.ResumenSemana){
                    this.cuadrante[ultElemIndex].TotalSemana = infoDiaObj;
                    // this.cuadrante[ultElemIndex].Domingo = element.TiendaDependientaFecha + "     Horas: " + formatoHora.format(element.Horas) + "\r\n" + element.vbpi;
                  }
                  // this.cuadrante[ultElemIndex].TotalSemana = infoSemanaObj;
                  // this.cuadrante[ultElemIndex].TotalSemana = "     Horas: " + formatoHora.format(TotalHorasSemana);

                  dptaAnt = element.Dependienta;
                }
              });
              // }
              resolve(true);
          })});
      },
      // descargarPDF () {
      //   this.procesarCuadrantes(false).then(res =>{
      //     var descarga = document.createElement("a");
      //     descarga.href = this.urlRaiz + "/Files/CuadranteSemanal.pdf" ;
      //     descarga.target = "_blank";
      //     descarga.download = "CuadranteSemanal.pdf";
      //     var clickEvent = new MouseEvent('click', { 'view':window, 'bubbles': true, 'cancelable': true });
      //     descarga.dispatchEvent(clickEvent);
      //   });
      // },
      descargarPDF() {
        return new Promise((resolve) => {
          var controllerParameters = {
                    Action: "GEN_CUADRANTE_SEMANAL_TIENDA_PDF",
                    Fecha: this.fecha,
                    DirId: this.dir.DirId
          } ;       
          var AuthToken = localStorage.getItem('token');
          axios({ method: "POST", "url": this.urlRaiz + "/api/dir", "data": JSON.stringify(controllerParameters), "headers": {"content-type": "application/json", "Authorization": AuthToken } }).then(result => {
            if (result.status >= 200 && result.status <= 299){
              var descarga = document.createElement("a");
              descarga.href = this.urlRaiz + "/Files/CuadranteSemanal.pdf" ;
              descarga.target = "_blank";
              descarga.download = "CuadranteSemanal.pdf";
              var clickEvent = new MouseEvent('click', { 'view':window, 'bubbles': true, 'cancelable': true });
              descarga.dispatchEvent(clickEvent);
              resolve(true)
            }
          })
        })
      },
      compararArrayCuadrantes (a, b) {
        if (a.ResumenFecha){
            return 1;
        }
        else if (b.ResumenFecha){
          return -1;
        }
        else{
          if (a.Dependienta > b.Dependienta) {
            return 1;
          }
          if (a.Dependienta < b.Dependienta) {
            return -1;
          }
        }
        // a must be equal to b
        return 0;
      },
      formatHoras(horas) {
        console.log(horas);
        // Expresión regular para encontrar bloques de horas seguidos opcionalmente por una o más letras
        const regex = /(\d{2}:\d{2} - \d{2}:\d{2})(\s*[A-Za-z]{1,2})?/g;
        let result = '';
        let match;

        // Usamos un bucle para procesar cada coincidencia encontrada
        while ((match = regex.exec(horas)) !== null) {
          // match[1] es el bloque de horas
          const hourBlock = match[1].trim();
          // match[2] es una o más letras (si existen)
          const letters = match[2] ? `<strong>${match[2].trim()}</strong>` : '';
          // Construimos el string final con horas y letras en negrita
          result += `${hourBlock} ${letters} `;
        }

        return result.trim(); // Devolvemos el string final procesado
      }
  },
}
</script>
<style>
  .col_dpta {
    min-width: 250px;
  }

  .cabecera-impresion {
    display: none;
  }

  @media print {
    @page {
      size: A3 landscape;
      margin: 4mm;
    }

    .no-print {
      display: none !important;
    }

    .cabecera-impresion {
      display: block;
    }

    #cuadrante-imprimible {
      width: 100%;
    }

    table {
      width: 100%;
      border-collapse: collapse;
    }

    thead {
      display: table-header-group;
    }

    tr {
      page-break-inside: avoid;
    }

    th,
    td {
      font-size: 9px;
    }

    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
  }
</style>